  @if (inventoryAction()) {
    <div class="expanded-row-content">
      @if(inventoryAction().document) {
      <div class="document-container">
        <div class="document" [ngClass]="{'even': evenRow}">
          <div class="document-name">
            {{adminService.getText(inventoryAction().document.sti_type || inventoryAction().document.type)}}
            @if (inventoryAction()?.document?.correlative_id) {
              #{{ inventoryAction()?.document?.correlative_id }}
            }
          </div>
          <div class="document-data">
            Creado {{inventoryAction().document.created_at | date}}
          </div>
          <div class="document-data">
            {{inventoryAction().document.status.name}}
          </div>
          
          <div class="expander"></div>
          <div class="document-button">
            <button
                mat-button
                class="primary"
                go-to-details
                [element]="inventoryAction().document"
                mode="modal">
              <mat-icon>visibility</mat-icon> Ver documento
            </button>
          </div>
        </div>
      </div>
      }
      <div class="product-col">
        <div class="products-container" >
          <div *ngFor="let product of paginatedProducts" class="product" [ngClass]="{'even': evenRow}">

            <div class="quantity">
              {{ product.quantity }}x
            </div>
            <div class="description">
              <div class="name">
                {{ product.product?.name }}
              </div>
              <div class="code">
                {{product.product?.code}}
              </div>
            </div>
            <div class="amount">
              {{product.amount | money}}
            </div>

          </div>
        </div>
        <div class="paginator">
          <button mat-button (click)="previousPage()" [disabled]="currentPage === 0"><mat-icon>arrow_back_ios</mat-icon></button>
          <span>{{currentPage + 1}} / {{totalPages}}</span>
          <button mat-button (click)="nextPage()" [disabled]="currentPage === totalPages - 1"><mat-icon>arrow_forward_ios</mat-icon></button>
        </div>
      </div>
     
      <div class="expander"></div>
    
      <div class="action-container">
        <div class="action" [ngClass]="{'even': evenRow}">

          <div class="document-name">
            {{titleForType(inventoryAction().type)}} #{{ inventoryAction().correlative_id }}
          </div>
          <div class="document-data">
            Total:{{ getTotalAmount() | money}}
          </div>
          <div class="expander"></div>
          <div class="action-button">
            <button 
                mat-button
                go-to-details
                [element]="inventoryAction()"
                mode="modal"
                class="primary">
              <mat-icon>visibility</mat-icon> Ver detalles
            </button>
          </div>
          
        </div>
      </div>
      
    </div>
  }@else {
    <div class="loading"> 
      <mat-spinner class="small"></mat-spinner>
    </div>
  }


